<template>
	<div class="container">
		<button class="not-position-btn" :style="windowWidth > 1500 ? 'top: 55px;' : 'top: 95px;'" @click="handleSearch('1')">无位置店铺</button>
		<div class="search-container">
			<div ref="areaListContent" class="area-list-content pl4">
				<el-button
					size="small"
					@click="areaListlVisiable = !areaListlVisiable"
				>
					选择显示自定义区域<i
						class="el-icon-arrow-down el-icon--right"
					></i>
				</el-button>
				<ul v-show="areaListlVisiable">
					<li>
						<el-checkbox
							v-model="areaCheckedAll"
							@change="handleAreaCheckAll"
							>全选</el-checkbox
						>
					</li>
					<li v-for="(item, index) in areaList" :key="index">
						<el-checkbox-group
							v-model="areaCheckList"
							@change="handleAreaCheckList"
						>
							<el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
						</el-checkbox-group>
						<img
							class=""
							src="@/assets/images/delete.png"
							title="删除"
							alt=""
							@click="handleDeleteArea(item.id)"
						/>
					</li>
				</ul>
			</div>
			<div ref="channelContent" class="channel-content">
				<el-button
					size="small"
					@click="channelVisiable = !channelVisiable"
				>
					渠道<i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<ul v-show="channelVisiable">
					<li>
						<el-checkbox v-model="channelsCheckedAll" @change="handleChannelsCheckAll">全选</el-checkbox>
					</li>
					<li v-for="(item,i) in channelsList">
						<el-checkbox v-model="item.checked" @change="handleChannelsCheckList">{{ item.channelName }}</el-checkbox>
					</li>
				</ul>
			</div>
			<el-input v-model.trim="agentName" class="width160" clearable size="small" placeholder="店铺名称"></el-input>
			<!-- <el-input v-model="agentTag1" class="width160 ml10" clearable size="small" placeholder="据点分类"></el-input> -->
			<el-select v-model="agentTag1" class="width160 ml10" size="small" placeholder="据点分类" clearable>
				<el-option label="分公司" value="分公司"></el-option>
				<el-option label="外仓" value="外仓"></el-option>
				<el-option label="营业所" value="营业所"></el-option>
			</el-select>
			<!-- <el-input v-model="agentTag2" class="width160 ml10" clearable size="small" placeholder="销售模式"></el-input> -->
			<div :style="windowWidth > 1500 ? 'display: inline-block;' : 'display: block;padding: 4px;'">
				<span class="ml10 fs13">销售(上月):</span>
				<el-select class="width120 ml10" v-model="saletype" clearable size="small" placeholder="请选择">
					<el-option
						v-for="item in saletypes"
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input v-model.number="ltVal" :minlength="1" :maxlength="8"
					@input="lformatInput" class="width80 ml10" clearable size="small" placeholder=""></el-input> ~
				<el-input v-model.number="gtVal" :minlength="1" :maxlength="8"
					@input="gformatInput" class="width80" clearable size="small" placeholder=""></el-input>
				<el-checkbox v-model="oldRoute" class="ml10" @change="handleOldRoute()">原路线</el-checkbox>
				<button class="search-btn" @click="handleSearch('0')">检索</button>
			</div>
			<div class="add-polygon-content">
				<img
					src="@/assets/images/csel2.png"
					title="店铺圈选"
					alt=""
					@click="handleStartDraw"
				/>
				<div ref="areaEditContent">
					<img
						src="@/assets/images/area.png"
						title="区域编辑"
						@click="areaEditVisiable = !areaEditVisiable"
					/>
					<ul ref="areaEditUl" v-show="areaEditVisiable">
						<li>
							<el-button size="small" @click="handleNewBuiltArea">新建</el-button>
						</li>
						<li>
							<el-button size="small" @click="handleStartArea">开始编辑</el-button>
						</li>
						<li>
							<el-button size="small" @click="handleEndArea">结束编辑</el-button>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="left-table-content" :style="windowWidth > 1500 ? 'height: calc(100vh - 117px);' : 'height: calc(100vh - 157px);'">
				<div class="group-box">
					<span>添加需要编辑的路线：</span>
					<!-- <img
						class="icon-s ml10"
						src="@/assets/images/search.png"
						@click="handleChoiceRoute"
						alt=""
					/> -->
					<img
						class="icon-s imagestyle ml10"
						src="@/assets/images/addRoute.png"
						@click="handleChoiceRoute"
						alt=""
					/>
				</div>
				<el-table
					class="route-table"
					ref="multipleTable"
					border
                    :height="tableHeight"
					:data="routeList"
					:cell-style="cellStyle"
					:header-cell-style="{
						background: 'rgba(200, 204, 215,.6)',
						color: '#333333'
					}"
					:row-key="
						row => {
							return row.routeId;
						}
					"
					@select-all="handleSelectAll"
					@select="handleSelect"
					@cell-click="handleCellClick"
				>
					<el-table-column
						class-name
						type="selection"
						width="42"
						align="center"
						:reserve-selection="true"
					>
					</el-table-column>
					<el-table-column prop="routeName" class-name="pl3" label="路线" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column label="周期" width="40" align="center">
						<template slot-scope="scope">
							<span class="view-btn" v-if="scope.row.routeId != 0" @click="handleChangeCycle(scope.row.routeId)">调期</span>
						</template>
					</el-table-column>
					<el-table-column label="类型" width="40" align="center">
						<template slot-scope="scope">
							{{ scope.row.routeId === 0 ? '' : routeTypes[scope.row.routeType] }}
						</template>
					</el-table-column>
					<el-table-column width="40" align="center">
						<template slot="header" slot-scope="scope">
							<span class="view-btn" @click="handleRouteStatistics">>></span>
						</template>
						<template slot-scope="scope">
							<span v-if="scope.row.routeId == 0 || scope.row.posStatus === null" style="display: block;height: 37px;"></span>
							<img
								v-else
								class="icon-img"
								:src="routePositionStatus[scope.row.posStatus]"
								title="地图"
								@click="handleEditRoute(scope.row)"
								alt=""
							/>
						</template>
					</el-table-column>
				</el-table>
				<div class="route-btn-box">
					<img
						class="icon-img"
						style="vertical-align: middle;"
						src="@/assets/images/import.png"
						title="导入"
						alt=""
						@click="handleExport"
					/>
					<input style="display:none;" ref="uploadExcel" type="file" id="uploadExcel" @change="importTable($event)">
					<img
						class="icon-img ml10"
						style="vertical-align: middle;"
						src="@/assets/images/downUrl.png"
						title="导出"
						@click="handleDownload"
						alt=""
					/>
					<img
						class="icon-img ml10"
						style="vertical-align: middle;"
						src="@/assets/images/down.png"
                        @click="downloadDemo"
						title="下载模板"
						alt=""
					/>
					<button @click="handlePub" class="search-btn fr">发布</button>
					<img
						class="icon-img fr ml10"
						style="vertical-align: middle;"
						src="@/assets/images/delete.png"
						@click="handleDeleteRoute"
						title="删除"
						alt=""
					/>
					<img
						class="icon-img imagestyle fr"
						style="vertical-align: middle;"
						src="@/assets/images/reset.png"
						@click="handleResetRoute"
						title="重置路线"
						alt=""
					/>
				</div>
			</div>
			<div class="right-map-content">
				<div id="container"></div>
			</div>
		</div>
		<!-- 店铺圈选结果 -->
		<changeAgent ref="changeAgent" @deleteAgent="changeRoute" @changeRoute="changeRoute" @handleCancelDraw="handleCancelDraw"></changeAgent>
		<!-- 路线编排 -->
		<editRoute ref="editRoute" @changeRoute="changeRoute"></editRoute>
		<!-- 选择路线 -->
		<choiceRoute ref="choiceRoute" @routeInfoList="changeRoute"></choiceRoute>
		<!-- markerInfo -->
		<editMarker ref="editMarker" @deleteAgent="changeRoute" @changeRoute="changeRoute"></editMarker>
		<!-- 路线信息 -->
		<routeInfo ref="routeInfo" @changeRouteType="changeRouteType"></routeInfo>
		<!-- 无位置 -->
		<notPosition ref="notPosition" @handleEditRoute="handleEditRoute"></notPosition>
		<!-- 无路线 -->
		<notRoute ref="notRoute" @handleEditRoute="handleEditRoute"></notRoute>
		<!-- 路线颜色选择 -->
		<choiceColor ref="choiceColor" @routeInfoList="changeRoute"></choiceColor>
		<!-- 路线客商渠道统计 -->
		<routeSum ref="routeSum"></routeSum>
		<!-- 路线客商配送周期调整 -->
		<changeCycle ref="changeCycle"></changeCycle>
	</div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader"
import changeAgent from "./components/change-agent.vue"
import editRoute from "./components/edit-route.vue"
import choiceRoute from "./components/choice-route.vue"
import choiceColor from "./components/choice-color.vue"
import editMarker from "./components/edit-marker.vue"
import routeInfo from "./components/route-info.vue"
import notPosition from "./components/not-position.vue"
import notRoute from "./components/not-route.vue"
import routeSum from "./components/route-sum.vue"
import changeCycle from "./components/change-cycle.vue"
import axios from "axios"
export default {
	components: {
		changeAgent,
		editRoute,
		choiceRoute,
		editMarker,
		routeInfo,
		notPosition,
		choiceColor,
		notRoute,
		routeSum,
		changeCycle
	},
	data() {
		return {
			// 店铺名称
			agentName: "",
			// 区域下拉显示
			areaListlVisiable: false,
			// 区域下拉全选
			areaCheckedAll: false,
			// 区域checkbox列表
			areaCheckList: [],
			// 渠道下拉显示
			channelVisiable: false,
			// 渠道下拉全选
			channelsCheckedAll: true,
			// 渠道列表
			channelsList: [],
			// 路线数组
			routeList: [],
			AMap: null, //保存地图api，防止报错
			map: null,
			// 区域编辑按钮
			areaEditVisiable: false,
			// 点击checkbox生成新的对象，储存marker
			routeObj: {},
			// 颜色列表
			color_list: [
				"#ff2121",
				"#4b5cc4",
				"#00bc12",
				"#801dae",
				"#fa8c35",
				"#ff0097",
				"#75878a",
				"#2edfa3",
				"#cca4e3",
				"#eacd76"
			],
			// 是否处于画圈状态下
			drawing: false,
			// 是否处于鼠标左键按下状态下
			isMouseDown: false,
			// 存储画出折线点的数组
			polyPointArray: [],
			// 上次操作画出的折线
			lastPolyLine: null,
			// 画圈完成后生成的多边形
			polygonAfterDraw: null,
			// 圈中的店铺数据
			selectedAgentList: [],
			// 区域多边形
			areaPolygon: null,
			// 区域编辑
			polygonEditor: null,
			// 区域列表
			areaList: [],
			// 在地图上展示路线坐标的列表
			routeSelection: [],
			// 组织结构列表
			groupList: [],
			// 当前组织id
			groupId: '',
            tableHeight: 200,
			// 销售类型
			saletypes: [
				{
					value: '1',
          			label: '全SKU_累计'
				},
				{
					value: '2',
          			label: '全SKU_日均'
				},
				{
					value: '3',
          			label: '原味_累计'
				},
				{
					value: '4',
          			label: '原味_日均'
				},
				{
					value: '5',
          			label: '低糖_累计'
				},
				{
					value: '6',
          			label: '低糖_日均'
				},
				{
					value: '7',
          			label: '500亿_累计'
				},
				{
					value: '8',
          			label: '500亿_日均'
				},
				{
					value: '9',
          			label: '原味6_累计'
				},
				{
					value: '10',
          			label: '原味6_日均'
				},
				{
					value: '11',
          			label: '低糖6_累计'
				},
				{
					value: '12',
          			label: '低糖6_日均'
				},
				{
					value: '13',
          			label: '蜜桃_累计'
				},
				{
					value: '14',
          			label: '蜜桃_日均'
				}
			],
			saletype: '',
			// 小
			ltVal: '',
			// 大
			gtVal: '',
			// 路线状态
			routePositionStatus: {
				0: require('@/assets/images/map_0.png'),
				1: require('@/assets/images/map_1.png'),
				2: require('@/assets/images/map_2.png'),
			},
			// 路线对应颜色
			route_color_obj: {},
			// 路线对应agents
			route_agent_obj: {},
			// 路线类型
			routeTypes: {
				0: 'Min',
				1: '单人',
				2: '双人'
			},
			// 据点分类
			agentTag1: '',
			// 销售模式
			agentTag2: '',
			// 屏幕宽度
			windowWidth: 1500,
			// 不在左侧列表的数据
			leftList: [],
			// 原路线
			oldRoute: false
		};
	},
    created() {
		this.windowWidth = window.innerWidth;
        this.tableHeight = this.windowWidth > 1500 ? window.innerHeight - 202 : window.innerHeight - 242;
    },
	mounted() {
		this.initAMap();
		// 点击区域下拉列表外,区域下拉列表隐藏
		document.addEventListener("click", this.handleClickOutside);
		// // 绑定resize
		// window.addEventListener('resize', ()=>{
		// 	this.windowWidth = window.innerWidth;
		// })
	},
	unmounted() {
		this.map?.destroy();
	},
	beforeDestroy() {
		// 点击区域下拉列表外,区域下拉列表隐藏
		document.removeEventListener("click", this.handleClickOutside);
	},
	destroy() {
		// // 解绑resize
		// window.removeEventListener('resize', ()=>{
		// 	this.windowWidth = window.innerWidth;
		// })
	},
	methods: {
		// 销量仅允许输入数字
		lformatInput(value) {
			this.ltVal = value.replace(/^0+(\d)|[^\d]+/g, '')
		},
		// 销量仅允许输入数字
		gformatInput(value) {
			this.gtVal = value.replace(/^0+(\d)|[^\d]+/g, '')
		},
		// 路线checkbook表格td添加背景色
		cellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 0) {
				return {
					"background-color": row.color
				};
			}
			if (columnIndex == 1) {
				return {
					"cursor": "pointer"
				};
			}
		},
		// 初始化地图
		initAMap() {
			AMapLoader.load({
				key: "0323acfa782cd29101908e3bb3cd7e4f", // 申请好的Web端开发者Key，首次调用 load 时必填
				version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
				plugins: ["AMap.PolygonEditor"] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
			})
				.then(AMap => {
					this.map = new AMap.Map("container", {
						// 设置地图容器id
						viewMode: "3D", // 是否为3D地图模式
						zoom: 11, // 初始化地图级别
						center: [121.472644, 31.231706] // 初始化地图中心点位置
					});
					this.AMap = AMap;
					this.initMapMouseHandle(AMap); //调用初始化画圈事件
					// 获取组织机构
					this.getBusSelectList();
				})
				.catch(e => {
					console.log(e);
				});
		},
		// 组织部门
		getBusSelectList() {
			this.groupId = window.sessionStorage.getItem('groupId') || '';
			// 获取渠列表
			this.getChannelsList();
			// 获取已经添加的路线
			this.routeInfoList();
			// 获取区域列表
			this.routeMapListArea();
		},
		// 变更组织部门
		handleChangeGroup() {
			// 清空店铺勾选
			this.$refs.multipleTable.clearSelection();
			// 变更组织后清除地图marker
			this.map.clearMap();
			// 地图返回上海原点
			this.map.setZoomAndCenter(11, [121.472644, 31.231706]);
			// 获取已经添加的路线
			this.routeInfoList();
			// 获取区域列表
			this.routeMapListArea();
		},
		// 选择路线
		handleChoiceRoute() {
			this.$refs.choiceRoute.init(this.groupId);
		},
		// 获取路线数据
		routeInfoList() {
			this.$request
				.post("routeMapListRoute", true, {
					groupId: this.groupId
				})
				.then(res => {
					// 无路线店铺
					let route_color_obj = {
						0: "#AAAAAA"
					};
					let route_agent_obj = {
						0: []
					};
					for (let index = 0; index < res.data.length; index++) {
						const element = res.data[index];
						if(element.color) {

						}else {
							element.color = this.color_list[Number(String(index).slice(-1))];
						}
						route_color_obj[element.routeId] = element.color;
						route_agent_obj[element.routeId] = [];
					}
					this.route_color_obj = route_color_obj;
					this.route_agent_obj = route_agent_obj;
					this.routeList = res.data;
					this.routeList.unshift({
						routeId: 0,
						routeName: '无路线（店铺）',
						color: '#AAAAAA'
 					});
				});
		},
		// 获取区域列表
		routeMapListArea() {
			this.$request
				.post("routeMapListArea", false, {
					groupId: this.groupId
				})
				.then(res => {
					if(res.code == "0") {
						this.areaList = res.data;
						for (let index = 0; index < this.areaList.length; index++) {
							const item = this.areaList[index];
							if(this.areaCheckList.includes(item.id)) {
								// 多边形轮廓线的节点坐标数组
								let path = [];
								const points = JSON.parse(item.point);
								for (const point of points) {
									path.push(new AMap.LngLat(point.lng, point.lat));
								}
								// 创建多边形 Polygon 实例
								const color = this.color_list[index];
								var polygon = new AMap.Polygon({
									path: path,
									fillColor: color, // 多边形填充颜色
									fillOpacity: 0.3,
									borderWeight: 2, // 线条宽度，默认为 1
									strokeColor: color, // 线条颜色
									strokeOpacity: 0.9
								});
								// 区域id设置
								polygon.setExtData({
									id: item.id,
									name: item.name
								});
								polygon.on("click", e => {
									this.areaPolygon = e.target;
								});
								//多边形 Polygon对象添加到 Map
								this.map.add(polygon);
								// 区域设置编入
								item.polygon = polygon;
								// 区域状态是否显示
								item.status = 'show';
								// 区域是否处在编辑状态
								item.polygonEditor = false;
							}
						}
					}
				});
		},
		// 获取渠道列表
		getChannelsList() {
			axios.get(this.$api['routeMapChannels'].url)
				.then(response => {
					// 请求成功处理
					for (const iterator of response.data.data) {
						iterator.checked = true;
					}
					this.channelsList = response.data.data;
				})
				.catch(error => {
					// 请求失败处理
					console.error(error);
				});
		},
		// 路线全选
		handleSelectAll(val) {
			// 全选只勾选除无路线的前五个，已勾选一个那就再勾选4个依此类推
			// 除无路线以外已经勾选的数量
			let routeNum = 0;
			// 已勾选的路线中是否包含无路线
			let noRouteFlag = false;
			for (const iterator of this.routeSelection) {
				if(iterator.routeId == 0) {
					noRouteFlag = true;
				}else {
					routeNum++;
				}
			}
			// 小于五个补全五个
			if(routeNum < 5 && val.length != 0 && (val.length - 1) != routeNum) {
				let routeSelection = [];
				// 取消选择
				this.$refs.multipleTable.clearSelection();
				// 只保留前五个
				for (let i = 0; i < 6; i++) {
					if(val[i]?.routeId) {
						if(noRouteFlag) {
							this.$refs.multipleTable.toggleRowSelection(val[i], true);
							routeSelection.push(val[i]);
						}else {
							if(val[i].routeId != 0) {
								this.$refs.multipleTable.toggleRowSelection(val[i], true);
								routeSelection.push(val[i]);
							}
						}
					}
				}
				this.routeSelection = routeSelection;
			}
			// 超过五个全部勾除
			else {
				// 取消选择
				this.$refs.multipleTable.clearSelection();
				this.routeSelection = [];
			}
			let selection = this.routeSelection;
			if(selection.length == 0) {
				for (const key in this.route_agent_obj) {
					const agents = this.route_agent_obj[key];
					if(agents.length > 0) {
						for (let index = 0; index < agents.length; index++) {
							const element = agents[index];
							if(element.marker) {
								this.map.remove(element.marker);
								element.markerStatus = 'hide';
								element.marker = null;
							}
						}
						this.route_agent_obj[key] = [];
					}
				}
				for (const node of this.leftList) {
					if(node.marker) {
						this.map.remove(node.marker);
						node.markerStatus = 'hide';
						node.marker = null;
					}
				}
				this.leftList = [];
			}else {
				this.handleMultipleRoute(selection);
			}
		},
		handleMultipleRoute(selection) {
			if(selection.length == 0) {
				return
			}
			let routeIds = selection.map(obj => obj.routeId);
			this.$request
				.post("routeMapRouteAgents", true, {
					routeIds: routeIds,
					groupId: this.groupId
				})
				.then(res => {
					for (let index = 0; index < res.data.length; index++) {
						const item = res.data[index];
						if (item.posLat) {
							// 点标记显示内容，HTML要素字符串
							var markerContent = `
							<div class="custom-content-marker">
								<svg t="1704956719062"
									class="icon" viewBox="0 0 1024 1024"
									version="1.1" xmlns="http://www.w3.org/2000/svg"
									p-id="4708" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30">
									<path d="M472.535913 1003.339745C181.939986 582.061852 128 538.825863 128 383.999903 128 171.921956 299.921956 0 511.999903 0s383.999903 171.921956 383.999902 383.999903c0 154.825961-53.939986 198.06195-344.535913 619.339842-19.069995 27.547993-59.859985 27.545993-78.927979 0z"
									p-id="4709" fill="${this.route_color_obj[item.routeId]}">
									</path>
								</svg>
								<div>${item.deliverSort}</div>
							</div>
							`;
							let marker = new AMap.Marker({
								content: markerContent,
								position: [item.posLng, item.posLat]
							});
							let self = this;
							marker.on('click',function(e) {
								self.handleEditMarker(item)
							});
							marker.setMap(this.map);
							// 渠道
							let channelList = this.channelsList.filter((item) => { return item.checked }).map(obj => obj.channelCode);
							if(channelList.includes(item.channelCode)) {
								item.markerStatus = 'show';
							}else {
								marker.hide();
								item.markerStatus = 'hide';
							}
							item.marker = marker;
						}else {
							item.marker = null;
							item.markerStatus = 'hide';
						}
						this.route_agent_obj[item.routeId].push(item);
					}
					// 地图视野自适应
					this.map.setFitView();
				});
		},
		// 路线单选
		handleSelect(selection, row) {
			this.routeSelection = selection;
			// 判断勾选还是勾除
			// 勾选
			if (selection.find(item => item.routeId == row.routeId)) {
				this.$request
					.post("routeMapRouteAgents", true, {
						routeIds: [row.routeId],
						groupId: this.groupId
					})
					.then(res => {
						for (let index = 0; index < res.data.length; index++) {
							const item = res.data[index];
							if (item.posLat) {
								// 点标记显示内容，HTML要素字符串
								var markerContent = `
								<div class="custom-content-marker">
									<svg t="1704956719062"
										class="icon" viewBox="0 0 1024 1024"
										version="1.1" xmlns="http://www.w3.org/2000/svg"
										p-id="4708" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30">
										<path d="M472.535913 1003.339745C181.939986 582.061852 128 538.825863 128 383.999903 128 171.921956 299.921956 0 511.999903 0s383.999903 171.921956 383.999902 383.999903c0 154.825961-53.939986 198.06195-344.535913 619.339842-19.069995 27.547993-59.859985 27.545993-78.927979 0z"
										p-id="4709" fill="${this.route_color_obj[item.routeId]}">
										</path>
									</svg>
									<div>${item.deliverSort}</div>
								</div>
								`;
								let marker = new AMap.Marker({
									content: markerContent,
									position: [item.posLng, item.posLat]
								});
								let self = this;
								marker.on('click',function(e) {
									self.handleEditMarker(item)
								});
								marker.setMap(this.map);
								// 渠道
								let channelList = this.channelsList.filter((item) => { return item.checked }).map(obj => obj.channelCode);
								if(channelList.includes(item.channelCode)) {
									item.markerStatus = 'show';
								}else {
									marker.hide();
									item.markerStatus = 'hide';
								}
								item.marker = marker;
							}else {
								item.marker = null;
								item.markerStatus = 'hide';
							}
							this.route_agent_obj[item.routeId].push(item);
						}
						// 地图视野自适应
						this.map.setFitView();
					});
			}
			// 勾除
			else {
				for (let index = 0; index < this.route_agent_obj[row.routeId].length; index++) {
					const item = this.route_agent_obj[row.routeId][index];
					if (item.marker) {
						this.map.remove(item.marker);
						item.markerStatus = 'hide';
						item.marker = null;
					}
				}
				this.route_agent_obj[row.routeId] = [];
			}
		},
		// 点击左侧路线列表中的路线
		handleCellClick(row, column, cell, event) {
			// 对比路线信息
			if(column.label == '路线') {
				// 如果路线信息弹窗打开状态，则关闭弹窗
				if(this.$refs.routeInfo.dialogVisible) {
					this.$refs.routeInfo.dialogVisible = false;
				}
				if(this.$refs.notPosition.dialogVisible) {
					this.$refs.notPosition.dialogVisible = false;
				}
				if(this.$refs.notRoute.dialogVisible) {
					this.$refs.notRoute.dialogVisible = false;
				}
				// 无路线
				if(row.routeId == 0) {
					this.$refs.notRoute.init(row);
				}else {
					this.$refs.routeInfo.init(row);
				}
			}
			// 选择路线颜色
			if(column.type == "selection" && row.routeId != 0) {
				this.$refs.choiceColor.init(row);
			}
		},
		// 初始化鼠标画圈事件
		initMapMouseHandle(AMap) {
			// 鼠标移动事件处理程序
			this.map.on("mousemove", e => {
				if (this.isMouseDown) {
					// 将坐标添加到lastPolyLine数组中
					const point = [e.lnglat.lng, e.lnglat.lat];
					this.polyPointArray.push(point);
					// 如果已存在上一条折线，则移除
					if (this.lastPolyLine) {
						this.map.remove(this.lastPolyLine);
						this.lastPolyLine = null;
					}
					// 使用路径规划实现一个圆圈
					const polyline = new AMap.Polyline({
						path: this.polyPointArray,
						strokeColor: "#4794f5",
						strokeOpacity: 2
					});
					this.map.add(polyline);
					this.lastPolyLine = polyline;
				}
			});
			// 鼠标按下事件处理程序
			this.map.on("mousedown", () => {
				// 移除上一条折线并初始化变量
				if (this.drawing) {
					this.lastPolyLine && this.map.remove(this.lastPolyLine);
					this.lastPolyLine = null;
					this.polyPointArray = [];
					this.isMouseDown = true;
				}
			});
			// 鼠标松开事件处理程序
			document.addEventListener("mouseup", () => {
				if (this.drawing && this.isMouseDown) {
					// 退出画线状态，将 isMouseDown 设置为 false
					this.isMouseDown = false;
					// 添加多边形覆盖物,设置为禁止点击
					this.polygonAfterDraw = new AMap.Polygon({
						path: this.polyPointArray,
						strokeColor: "#4794f5",
						strokeOpacity: 1,
						fillColor: "#4794f5",
						fillOpacity: 0.3
					});
					this.map.add(this.polygonAfterDraw);
					this.handleEndDraw(); //收集信息
				}
			});
		},
		// 开始圈选
		handleStartDraw() {
			if (this.drawing) {
				this.$message({
					type: "error",
					dangerouslyUseHTMLString: true,
					message: '<p class="map-tips">已暂停圈选功能。</p>'
				});
				this.handleCancelDraw();
			} else {
				this.$message({
					type: "error",
					dangerouslyUseHTMLString: true,
					message: '<p class="map-tips">请在需要圈选的位置按住鼠标左键进行圈选。<br/>如需暂停圈选功能请再次点击右上角圈选按钮即可。</p>'
				});
				this.map.setStatus({
					doubleClickZoom: false, //是否开启双击缩放地图
					scrollWheel: false, //是否开启鼠标滚轮缩放地图
					dragEnable: false, //是否开启拖拽地图
					keyboardEnable: false //是否开启键盘操作地图
				});
				this.map.setDefaultCursor("pointer"); //通过 setDefaultCursor 方法设置地图的默认鼠标指针样式
				this.drawing = true;
			}
		},
		// 取消圈选
		handleCancelDraw() {
			this.map.setStatus({
				doubleClickZoom: true,
				scrollWheel: true,
				dragEnable: true,
				keyboardEnable: true
			});
			this.map.setDefaultCursor("default");
			this.drawing = false;
			this.selectedAgentList = [];
			if(this.lastPolyLine) {
				this.map.remove(this.lastPolyLine);
				this.lastPolyLine = null;
			}
			if(this.polygonAfterDraw) {
				this.map.remove(this.polygonAfterDraw);
				this.polygonAfterDraw = null;
			}
		},
		// 圈选结果
		handleEndDraw() {
			// 重置圈选数组
			this.selectedAgentList = [];
			// 判断地图上显示的marker是否在圈选中
			for (const route of this.routeSelection) {
				for (const agent of this.route_agent_obj[route.routeId]) {
					if (agent.posLng) {
						if (this.polygonAfterDraw.contains(new AMap.LngLat(agent.posLng, agent.posLat))) {
							this.selectedAgentList.push(agent);
						}
					}
				}
			}
			for (const agent of this.leftList) {
				if (agent.posLng) {
					if (this.polygonAfterDraw.contains(new AMap.LngLat(agent.posLng, agent.posLat))) {
						this.selectedAgentList.push(agent);
					}
				}
			}
			console.log(this.selectedAgentList)
			if(this.selectedAgentList.length > 0) {
				// 如果路线信息弹窗打开状态，则关闭弹窗
				if(this.$refs.routeInfo.dialogVisible) {
					this.$refs.routeInfo.dialogVisible = false;
				}
				if(this.$refs.notPosition.dialogVisible) {
					this.$refs.notPosition.dialogVisible = false;
				}
				if(this.$refs.notRoute.dialogVisible) {
					this.$refs.notRoute.dialogVisible = false;
				}
				// 圈选结果弹框
				this.$refs.changeAgent.init(this.selectedAgentList, this.groupId);
			}else {
				this.$message({
					type: "error",
					dangerouslyUseHTMLString: true,
					message: '<p class="map-tips">圈选区域没有店铺!</p>'
				});
				this.handleCancelDraw();
			}
		},
		// 新建区域
		handleNewBuiltArea() {
			this.$prompt("请输入区域名称", "保存自定义区域", {
				showInput: true,
				inputType: "text",
				inputValue: "",
				inputValidator: value => {
					if(value === "" || value.length > 10) {
						return false
					}else {
						return true
					}
				},
				inputErrorMessage: "可输入最大长度10位",
				confirmButtonText: "确定",
				cancelButtonText: "取消"
			})
				.then(({ value }) => {
					// 区域id
					let index = this.areaList.length;
					// 暂停正在编辑的区域
                    if(this.areaPolygon) {

                    }
					if (this.polygonEditor) {
						this.polygonEditor.close();
					}
					// 获取地图中心坐标
					let latlng = this.map.getCenter();
					// 多边形轮廓线的节点坐标数组
					var path = [
						new AMap.LngLat(latlng.lng + 0.05, latlng.lat),
						new AMap.LngLat(latlng.lng, latlng.lat + 0.05),
						new AMap.LngLat(latlng.lng - 0.05, latlng.lat),
						new AMap.LngLat(latlng.lng, latlng.lat - 0.05)
					];
					// 创建多边形 Polygon 实例
					const color = this.color_list[index];
					var polygon = new AMap.Polygon({
						path: path,
						fillColor: color, // 多边形填充颜色
						fillOpacity: 0.3,
						borderWeight: 2, // 线条宽度，默认为 1
						strokeColor: color, // 线条颜色
						strokeOpacity: 0.9,
						draggable: true
					});
					polygon.on("click", e => {
						this.areaPolygon = e.target;
					});
					this.areaPolygon = polygon;
					//多边形 Polygon对象添加到 Map
					this.map.add(polygon);
					// 后台添加新增区域
					let point = [
						{
							lng: latlng.lng + 0.05,
							lat: latlng.lat
						},
						{
							lng: latlng.lng,
							lat: latlng.lat + 0.05
						},
						{
							lng: latlng.lng - 0.05,
							lat: latlng.lat
						},
						{
							lng: latlng.lng,
							lat: latlng.lat - 0.05
						}
					];
					this.routeMapAddArea(value, JSON.stringify(point), polygon);
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "取消输入"
					});
				});
		},
		// 开始编辑区域
		handleStartArea() {
			// 暂停正在编辑的区域
			if (this.polygonEditor) {
				this.polygonEditor.close();
			}
			// 当前没有区域
			if (this.areaPolygon) {
				this.areaPolygon.setOptions({ draggable: false });
				// 区域添加编辑状态
				const extData = this.areaPolygon.getExtData();
				if (this.areaList.length > 1) {
					for (const item of this.areaList) {
						if(item.id == extData.id) {
							item.polygonEditor = true;
						}else {
							item.polygonEditor = false;
						}
					}
				}
				// 实例化多边形编辑器，传入地图实例和要进行编辑的多边形实例
				var polygonEditor = new AMap.PolygonEditor(
					this.map,
					this.areaPolygon
				);
				this.polygonEditor = polygonEditor;
				// 开启编辑模式
				polygonEditor.open();
			} else {
				this.$message({
					type: "info",
					message: "当前没有可开始编辑的区域"
				});
			}
		},
		// 结束区域编辑
		handleEndArea() {
			if (this.polygonEditor) {
				this.polygonEditor.close();
				this.polygonEditor = null;
				// 区域添加编辑状态修改为false
				for (const item of this.areaList) {
					item.polygonEditor = false;
				}
				// 区域添加编辑状态
				const extData = this.areaPolygon.getExtData();
				const past = this.areaPolygon.getPath();
				let point = [];
				for (const iterator of past) {
					point.push({
						lng: iterator.lng,
						lat: iterator.lat
					})
				}
				console.log(extData)
				this.routeMapUpdateArea(extData.id,JSON.stringify(point));
			}
		},
		// 区域下拉checkbox全选
		handleAreaCheckAll(value) {
			// 全选
			if (value) {
				for (let index = 0; index < this.areaList.length; index++) {
					const item = this.areaList[index];
					// 已经勾选并显示的区域
					if(this.areaCheckList.includes(item.id)) {}
					// 没有勾选上的区域
					else {
						this.areaCheckList.push(item.id);
						if(item.polygon) {
							// 区域状态是否显示
							item.status = 'show';
							item.polygon.show();
						}else {
							// 多边形轮廓线的节点坐标数组
							let path = [];
							const points = JSON.parse(item.point);
							for (const point of points) {
								path.push(new AMap.LngLat(point.lng, point.lat));
							}
							// 创建多边形 Polygon 实例
							const color = this.color_list[index];
							var polygon = new AMap.Polygon({
								bubble: true,
								path: path,
								fillColor: color, // 多边形填充颜色
								fillOpacity: 0.3,
								borderWeight: 2, // 线条宽度，默认为 1
								strokeColor: color, // 线条颜色
								strokeOpacity: 0.9
							});
							// 区域id设置
							polygon.setExtData({
								id: item.id,
								name: item.name
							});
							polygon.on("click", e => {
								this.areaPolygon = e.target;
							});
							//多边形 Polygon对象添加到 Map
							this.map.add(polygon);
							// 区域设置编入
							item.polygon = polygon;
							// 区域状态是否显示
							item.status = 'show';
							// 区域是否处在编辑状态
							item.polygonEditor = false;
						}
					}
				}
			} else {
				// 清空区域列表
				this.areaCheckList = [];
				// 如果有在编辑的区域，进行停止处理
				if (this.polygonEditor) {
					this.polygonEditor.close();
				}
				this.areaPolygon = null;
				this.polygonEditor = null;
				for (const item of this.areaList) {
					item.status = "hide";
					item.polygonEditor = false;
					if(item.polygon) {
						item.polygon.hide();
					}
				}
			}
		},
		// 区域下拉checkbox单选
		handleAreaCheckList(array) {
			// 全选按钮处理
			if (array.length == this.areaList.length) {
				this.areaCheckedAll = true;
			} else {
				this.areaCheckedAll = false;
			}
			for (let index = 0; index < this.areaList.length; index++) {
				const item = this.areaList[index];
				if (array.includes(item.id)) {
					if(item.polygon) {
						if (item.status == "hide") {
							item.status = "show";
							item.polygon.show();
						}
					}else {
						// 多边形轮廓线的节点坐标数组
						let path = [];
						const points = JSON.parse(item.point);
						for (const point of points) {
							path.push(new AMap.LngLat(point.lng, point.lat));
						}
						// 创建多边形 Polygon 实例
						const color = this.color_list[index];
						var polygon = new AMap.Polygon({
							bubble: true,
							path: path,
							fillColor: color, // 多边形填充颜色
							fillOpacity: 0.3,
							borderWeight: 2, // 线条宽度，默认为 1
							strokeColor: color, // 线条颜色
							strokeOpacity: 0.9
						});
						polygon.setExtData({
							id: item.id,
							name: item.name
						});
						polygon.on("click", e => {
							this.areaPolygon = e.target;
						});
						//多边形 Polygon对象添加到 Map
						this.map.add(polygon);
						// 区域设置编入
						item.polygon = polygon;
						// 区域状态是否显示
						item.status = 'show';
						// 区域是否处在编辑状态
						item.polygonEditor = false;
					}
				}
				else {
					if (item.status == "show") {
						item.status = "hide";
						if (item.polygonEditor) {
							item.polygonEditor = false;
							this.polygonEditor.close();
							this.areaPolygon = null;
							this.polygonEditor = null;
						}
						item.polygon.hide();
					}
				}
			}
		},
		// 渠道下拉checkbox全选
		handleChannelsCheckAll(value) {
			// 全选
			if (value) {
				for (const iterator of this.channelsList) {
					iterator.checked = true;
				}
			} else {
				for (const iterator of this.channelsList) {
					iterator.checked = false;
				}
			}
			// 渠道
			let channelList = this.channelsList.filter((item) => { return item.checked }).map(obj => obj.channelCode);
			for (const route of this.routeSelection) {
				for (let index = 0; index < this.route_agent_obj[route.routeId].length; index++) {
					const agent = this.route_agent_obj[route.routeId][index];
					if(agent.marker) {
						if(channelList.includes(agent.channelCode)) {
							agent.marker.show();
							agent.markerStatus = 'show';
						}else {
							agent.marker.hide();
							agent.markerStatus = 'hide';
						}
					}
				}
			}
		},
		// 渠道下拉checkbox单选
		handleChannelsCheckList() {
			// 全选按钮勾选状态
			let flag = true;
			for (const iterator of this.channelsList) {
				if(iterator.checked === false) {
					flag = false;
				}
			}
			if(flag) {
				this.channelsCheckedAll = true;
			}else {
				this.channelsCheckedAll = false;
			}
			// 渠道
			let channelList = this.channelsList.filter((item) => { return item.checked }).map(obj => obj.channelCode);
			for (const route of this.routeSelection) {
				for (let index = 0; index < this.route_agent_obj[route.routeId].length; index++) {
					const agent = this.route_agent_obj[route.routeId][index];
					if(agent.marker) {
						if(channelList.includes(agent.channelCode)) {
							agent.marker.show();
							agent.markerStatus = 'show';
						}else {
							agent.marker.hide();
							agent.markerStatus = 'hide';
						}
					}
				}
			}
		},
		// 点击区域外隐藏
		handleClickOutside(e) {
			// 区域列表
			const areaListContent = this.$refs.areaListContent;
			if (areaListContent && !areaListContent.contains(e.target)) {
				this.areaListlVisiable = false;
			}
			// 渠道列表
			const channelContent = this.$refs.channelContent;
			if (channelContent && !channelContent.contains(e.target)) {
				this.channelVisiable = false;
			}
			// 区域编辑列表
			// const areaEditContent = this.$refs.areaEditContent;
			// if (areaEditContent && !areaEditContent.contains(e.target)) {
			// 	this.areaEditVisiable = false;
			// }
		},
		// 删除区域
		handleDeleteArea(id) {
			this.$confirm("确定要删除此区域吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.$request
						.post("routeMapDeleteArea", true, {
							id: id
						})
						.then(res => {
							if(res.code == "0") {
								this.$message({
									type: "success",
									message: "删除成功!"
								});
								for (let index = 0; index < this.areaList.length; index++) {
									const item = this.areaList[index];
									if(item.id == id && item.polygon) {
										item.polygon.setMap(null);
									}
								}
								this.areaList = this.areaList.filter(item => item.id != id);
								this.areaCheckList = this.areaCheckList.filter(item => item != id);
							}
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除"
					});
				});
		},
		// 子页面删除店铺
		deleteAgent() {
			// 1.刷新路线列表
			this.routeInfoList();
			// 2.刷新地图数据
			// i.先清空地图
			for (const key in this.route_agent_obj) {
				const agents = this.route_agent_obj[key];
				if(agents.length > 0) {
					for (let index = 0; index < agents.length; index++) {
						const element = agents[index];
						if(element.marker) {
							this.map.remove(element.marker);
							element.markerStatus = 'hide';
							element.marker = null;
						}
					}
					this.route_agent_obj[key] = [];
				}
			}
			for (const node of this.leftList) {
				if(node.marker) {
					this.map.remove(node.marker);
					node.markerStatus = 'hide';
					node.marker = null;
				}
			}
			this.leftList = [];
			// ii.再渲染数据
			this.handleMultipleRoute(this.routeSelection);
		},
		// 子页面变更路线
		changeRoute() {
			// i.先清空地图
			for (const key in this.route_agent_obj) {
				const agents = this.route_agent_obj[key];
				if(agents.length > 0) {
					for (let index = 0; index < agents.length; index++) {
						const element = agents[index];
						if(element.marker) {
							this.map.remove(element.marker);
							element.markerStatus = 'hide';
							element.marker = null;
						}
					}
					this.route_agent_obj[key] = [];
				}
			}
			for (const node of this.leftList) {
				if(node.marker) {
					this.map.remove(node.marker);
					node.markerStatus = 'hide';
					node.marker = null;
				}
			}
			this.leftList = [];
			this.route_agent_obj = null;
			// 1.刷新路线列表
			this.$request
				.post("routeMapListRoute", true, {
					groupId: this.groupId
				})
				.then(res => {
					// 无路线店铺
					let route_color_obj = {
						0: "#AAAAAA"
					};
					let route_agent_obj = {
						0: []
					};
					for (let index = 0; index < res.data.length; index++) {
						const element = res.data[index];
						if(element.color) {

						}else {
							element.color = this.color_list[Number(String(index).slice(-1))];
						}
						route_color_obj[element.routeId] = element.color;
						route_agent_obj[element.routeId] = [];
					}
					this.route_color_obj = route_color_obj;
					this.route_agent_obj = route_agent_obj;
					this.routeList = res.data;
					this.routeList.unshift({
						routeId: 0,
						routeName: '无路线（店铺）',
						color: '#AAAAAA'
 					});
					// ii.再渲染数据
					this.handleMultipleRoute(this.routeSelection);
				});
		},
		// 路线编排
		handleEditRoute(route) {
			// 如果路线信息弹窗打开状态，则关闭弹窗
			if(this.$refs.routeInfo.dialogVisible) {
				this.$refs.routeInfo.dialogVisible = false;
			}
			if(this.$refs.notPosition.dialogVisible) {
				this.$refs.notPosition.dialogVisible = false;
			}
			if(this.$refs.notRoute.dialogVisible) {
				this.$refs.notRoute.dialogVisible = false;
			}
			this.$refs.editRoute.init(route, this.groupId);
		},
		// 单击marker事件
		handleEditMarker(cagent) {
			var p1 = cagent.marker.getPosition();
			var disList = [cagent];
			for (const key in this.route_agent_obj) {
				var agents = this.route_agent_obj[key];
				if(agents.length > 0) {
					for (const agent of agents) {
						if(agent.marker && agent.markerStatus == 'show' && (cagent.routeId != agent.routeId || cagent.agentId != agent.agentId)) {
							var p2 = agent.marker.getPosition();
							var distance = AMap.GeometryUtil.distance(p1, p2);
							// 两点小于10米弹列表
							if(Math.round(distance) <= 10) {
								disList.push(agent);
							}
						}
					}
				}
			}
			// 如果路线信息弹窗打开状态，则关闭弹窗
			if(this.$refs.routeInfo.dialogVisible) {
				this.$refs.routeInfo.dialogVisible = false;
			}
			if(this.$refs.notPosition.dialogVisible) {
				this.$refs.notPosition.dialogVisible = false;
			}
			if(this.$refs.notRoute.dialogVisible) {
				this.$refs.notRoute.dialogVisible = false;
			}
			if(disList.length == 1) {
				this.$refs.editMarker.init(cagent,this.groupId);
			}else {
				this.$refs.changeAgent.init(disList, this.groupId);
			}
		},
		// 新增区域接口提交
		routeMapAddArea(name, point, polygon) {
			this.$request
				.post("routeMapAddArea", false, {
					groupId: this.groupId,
					name: name,
					point: point
				})
				.then(res => {
					if(res.code == "0") {
						// 区域id设置
						polygon.setExtData({
							id: res.data.id,
							name: name
						});
						// 区域设置编入
						res.data.polygon = polygon;
						// 区域状态是否显示
						res.data.status = 'show';
						// 区域是否处在编辑状态
						res.data.polygonEditor = false;
						this.areaList.push(res.data)
						this.areaCheckList.push(res.data.id);
					}else {
						this.map.remove(this.areaPolygon);
					}
				});
		},
		// 更新区域接口提交
		routeMapUpdateArea(id, point) {
			console.log(id)
			console.log(point)
			this.$request
				.post("routeMapUpdateArea", false, {
					id: id,
					point: point
				})
				.then(res => {
					if(res.code == "0") {
						for (const item of this.areaList) {
							if(item.polygon || item.status == 'show') {
								this.map.remove(item.polygon);
								item.status = 'hide';
								item.polygonEditor = false;
								item.polygon = null;
							}
						}
						this.areaList = [];
						// 获取区域列表
						this.routeMapListArea();
					}
				});
		},
		// 导出
		handleDownload() {
			let routeIds = this.routeSelection.map(obj => obj.routeId);;
			this.$request
				.post("routeMapExport", true, {
					routeIds: routeIds
				})
				.then(res => {
					if (res) {
						let downloadURL = res.data;
						const linkNode = document.createElement("a");
						linkNode.style.display = "none";
						linkNode.href = downloadURL;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					}
				});
		},
        // 导出模板
        downloadDemo() {
            let downloadURL = "https://msslx.yakult.com.cn/files/download/template/route_map_template.xlsx";
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = downloadURL;
			document.body.appendChild(linkNode);
			linkNode.click(); //模拟在按钮上的一次鼠标单击
			URL.revokeObjectURL(linkNode.href); // 释放URL 对象
			document.body.removeChild(linkNode);
        },
		// 导入
		handleExport() {
			this.$refs.uploadExcel.value = '';
			let el = document.getElementById('uploadExcel');
            el.click();
		},
		// 导入
		importTable(e) {
			// 如果路线信息弹窗打开状态，则关闭弹窗
			if(this.$refs.routeInfo.dialogVisible) {
				this.$refs.routeInfo.dialogVisible = false;
			}
			if(this.$refs.notPosition.dialogVisible) {
				this.$refs.notPosition.dialogVisible = false;
			}
			if(this.$refs.notRoute.dialogVisible) {
				this.$refs.notRoute.dialogVisible = false;
			}
			let file = e.target.files[0];
			if(!['xls','xlsx'].includes(file.name.split('.').reverse()[0])) {
				this.$message.error('只支持excel格式的文件上传！');
				return
			}
			if(1024 * 1024 * 2 < file.size) {
				this.$message.error('只支持上传2M以内的文件，请调整文件分批导入！');
				return
			}
			if(file) {
				let that = this;
				let formdata = new FormData();
				formdata.append("file", file);
				formdata.append("groupId", that.groupId);
				that.$request.formData("routeMapImport", true, formdata).then(res => {
					if (res.data.length > 0) {
						let arr = res.data;
						let html = '<div style="height:350px;overflow: auto;">';
						for (let index = 0; index < arr.length; index++) {
							html += "<p>" + arr[index] + "</p>";
						}
						html += "</div>";
						that.$confirm(html, "提示", {
							dangerouslyUseHTMLString: true,
							showCancelButton: false,
							showConfirmButton: false,
							customClass: "customClass"
						})
							.then(() => {})
							.catch(() => {
								// 先清空勾选数据
								for (const key in that.route_agent_obj) {
									const agents = that.route_agent_obj[key];
									if(agents.length > 0) {
										for (let index = 0; index < agents.length; index++) {
											const element = agents[index];
											if(element.marker) {
												that.map.remove(element.marker);
												element.markerStatus = 'hide';
												element.marker = null;
											}
										}
										that.route_agent_obj[key] = [];
									}
								}
								for (const node of this.leftList) {
									if(node.marker) {
										this.map.remove(node.marker);
										node.markerStatus = 'hide';
										node.marker = null;
									}
								}
								this.leftList = [];
								// 清空店铺勾选
								that.$refs.multipleTable.clearSelection();
								that.routeSelection = [];
								that.routeInfoList();
							});
					}
				});
			}
		},
		// 检索/无位置店铺
		// type 0检索 1无位置店铺
		handleSearch(type) {
			if(this.routeSelection.length == 0 && !this.oldRoute) {
				this.$message.error('请选择路线');
				return
			}
			let channelCodes = this.channelsList.filter((item) => { return item.checked }).map(obj => obj.channelCode);
			this.$request
				.post("routeMapQuery", true, {
					groupId: this.groupId,
					routeIds: this.routeSelection.length == 0 ? null : this.routeSelection.map(obj => obj.routeId),
					type: this.saletype,
					agentName: this.agentName,
					agentTag1: this.agentTag1,
					agentTag2: this.agentTag2,
					ltVal: this.ltVal,
					gtVal: this.gtVal,
					nonPointFlag: type,
					channelCodes: channelCodes.length == this.channelsList.length ? ['-1'] : channelCodes,
					oldRouteId: this.oldRoute ? '-1' : ''
				})
				.then(res => {
					if(type == '1') {
						if(res.data.length == 0) {
							this.$message('未查询到相关店铺的信息');
						}else {
							this.$refs.notPosition.init(res.data);
						}
					}else {
						// 先清空勾选数据
						for (const key in this.route_agent_obj) {
							const agents = this.route_agent_obj[key];
							if(agents.length > 0) {
								for (let index = 0; index < agents.length; index++) {
									const element = agents[index];
									if(element.marker) {
										this.map.remove(element.marker);
										element.markerStatus = 'hide';
										element.marker = null;
									}
								}
								this.route_agent_obj[key] = [];
							}
						}
						for (const node of this.leftList) {
							if(node.marker) {
								this.map.remove(node.marker);
								node.markerStatus = 'hide';
								node.marker = null;
							}
						}
						this.leftList = [];
						// 再渲染检索数据
						for (let index = 0; index < res.data.length; index++) {
							const item = res.data[index];
							if (item.posLat) {
								// 点标记显示内容，HTML要素字符串
								var markerContent = `
								<div class="custom-content-marker">
									<svg t="1704956719062"
										class="icon" viewBox="0 0 1024 1024"
										version="1.1" xmlns="http://www.w3.org/2000/svg"
										p-id="4708" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30">
										<path d="M472.535913 1003.339745C181.939986 582.061852 128 538.825863 128 383.999903 128 171.921956 299.921956 0 511.999903 0s383.999903 171.921956 383.999902 383.999903c0 154.825961-53.939986 198.06195-344.535913 619.339842-19.069995 27.547993-59.859985 27.545993-78.927979 0z"
										p-id="4709" fill="${this.route_color_obj[item.routeId] ? this.route_color_obj[item.routeId] : '#AAAAAA'}">
										</path>
									</svg>
									<div>${ item.deliverSort ? item.deliverSort : index + 1 }</div>
								</div>
								`;
								let marker = new AMap.Marker({
									content: markerContent,
									position: [item.posLng, item.posLat]
								});
								let self = this;
								marker.on('click',function(e) {
									self.handleEditMarker(item)
								});
								marker.setMap(this.map);
								item.marker = marker;
								item.markerStatus = 'show';
							}else {
								item.marker = null;
								item.markerStatus = 'hide';
							}
							if(this.route_agent_obj[item.routeId]) {
								this.route_agent_obj[item.routeId].push(item);
							}else {
								this.leftList.push(item);
							}
						}
						// 地图视野自适应
						this.map.setFitView();
					}
				});
		},
		// 点击原路线清除marker
		handleOldRoute() {
			if(!this.oldRoute) {
				// 清空勾选数据
				for (const key in this.route_agent_obj) {
					const agents = this.route_agent_obj[key];
					if(agents.length > 0) {
						for (let index = 0; index < agents.length; index++) {
							const element = agents[index];
							if(element.marker) {
								this.map.remove(element.marker);
								element.markerStatus = 'hide';
								element.marker = null;
							}
						}
						this.route_agent_obj[key] = [];
					}
				}
				for (const node of this.leftList) {
					if(node.marker) {
						this.map.remove(node.marker);
						node.markerStatus = 'hide';
						node.marker = null;
					}
				}
				this.leftList = [];
			}
		},
		// 发布
		handlePub() {
			if(this.routeSelection.length == 0) {
				return
			}
			let routeIds = this.routeSelection.map(obj => obj.routeId);
			if(routeIds.includes(0) || routeIds.includes("0")) {
				this.$message.error('无路线（店铺）不能发布');
				return
			}
			this.$confirm("确认要正式发布选中的路线吗？发布后原路线信息将被作废！", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.$request
						.post("routeMapPubRoute", true, {
							groupId: this.groupId,
							routeIds: routeIds
						})
						.then(res => {
							if(res.code == "0") {
								this.$message({
									type: "success",
									message: "发布成功!"
								});
								// 先清空勾选数据
								for (const key in this.route_agent_obj) {
									const agents = this.route_agent_obj[key];
									if(agents.length > 0) {
										for (let index = 0; index < agents.length; index++) {
											const element = agents[index];
											if(element.marker) {
												this.map.remove(element.marker);
												element.markerStatus = 'hide';
												element.marker = null;
											}
										}
										this.route_agent_obj[key] = [];
									}
								}
								for (const node of this.leftList) {
									if(node.marker) {
										this.map.remove(node.marker);
										node.markerStatus = 'hide';
										node.marker = null;
									}
								}
								this.leftList = [];
								// 如果路线信息弹窗打开状态，则关闭弹窗
								if(this.$refs.routeInfo.dialogVisible && routeIds.includes(this.$refs.routeInfo.routeId)) {
									this.$refs.routeInfo.dialogVisible = false;
								}
								if(this.$refs.notPosition.dialogVisible) {
									this.$refs.notPosition.dialogVisible = false;
								}
								if(this.$refs.notRoute.dialogVisible) {
									this.$refs.notRoute.dialogVisible = false;
								}
								// 清空店铺勾选
								this.$refs.multipleTable.clearSelection();
								this.routeSelection = [];
								this.routeInfoList();
							}
						});
				})
				.catch(() => {

				});
		},
		// 删除路线
		handleDeleteRoute() {
			if(this.routeSelection.length == 0) {
				return
			}
			let routeIds = this.routeSelection.map(obj => obj.routeId);
			if(routeIds.includes(0) || routeIds.includes("0")) {
				this.$message.error('无路线（店铺）不能删除');
				return
			}
			this.$confirm("确认要删除选中的路线吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.$request
						.post("routeMapDeleteRouteMap", true, {
							groupId: this.groupId,
							routeIds: routeIds
						})
						.then(res => {
							if(res.code == "0") {
								this.$message({
									type: "success",
									message: "删除成功!"
								});
								// 先清空勾选数据
								for (const key in this.route_agent_obj) {
									const agents = this.route_agent_obj[key];
									if(agents.length > 0) {
										for (let index = 0; index < agents.length; index++) {
											const element = agents[index];
											if(element.marker) {
												this.map.remove(element.marker);
												element.markerStatus = 'hide';
												element.marker = null;
											}
										}
										this.route_agent_obj[key] = [];
									}
								}
								for (const node of this.leftList) {
									if(node.marker) {
										this.map.remove(node.marker);
										node.markerStatus = 'hide';
										node.marker = null;
									}
								}
								this.leftList = [];
								// 如果路线信息弹窗打开状态，则关闭弹窗
								if(this.$refs.routeInfo.dialogVisible && routeIds.includes(this.$refs.routeInfo.route.routeId)) {
									this.$refs.routeInfo.dialogVisible = false;
								}
								if(this.$refs.notPosition.dialogVisible) {
									this.$refs.notPosition.dialogVisible = false;
								}
								if(this.$refs.notRoute.dialogVisible) {
									this.$refs.notRoute.dialogVisible = false;
								}
								// 清空店铺勾选
								this.$refs.multipleTable.clearSelection();
								this.routeSelection = [];
								this.routeInfoList();
							}
						});
				})
				.catch(() => {

				});
		},
		// 重置路线
		handleResetRoute() {
			if(this.routeSelection.length == 0) {
				return
			}
			let routeIds = this.routeSelection.map(obj => obj.routeId);
			if(routeIds.includes(0) || routeIds.includes("0")) {
				this.$message.error('无路线（店铺）不能重置');
				return
			}
			this.$confirm("确认要重置选中的路线吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.$request
						.post("routeMapReset", true, {
							routeIds: routeIds
						})
						.then(res => {
							if(res.code == "0") {
								this.$message({
									type: "success",
									message: "重置成功!"
								});
								// 先清空勾选数据
								for (const key in this.route_agent_obj) {
									const agents = this.route_agent_obj[key];
									if(agents.length > 0) {
										for (let index = 0; index < agents.length; index++) {
											const element = agents[index];
											if(element.marker) {
												this.map.remove(element.marker);
												element.markerStatus = 'hide';
												element.marker = null;
											}
										}
										this.route_agent_obj[key] = [];
									}
								}
								for (const node of this.leftList) {
									if(node.marker) {
										this.map.remove(node.marker);
										node.markerStatus = 'hide';
										node.marker = null;
									}
								}
								this.leftList = [];
								// 如果路线信息弹窗打开状态，则关闭弹窗
								if(this.$refs.routeInfo.dialogVisible && routeIds.includes(this.$refs.routeInfo.route.routeId)) {
									this.$refs.routeInfo.dialogVisible = false;
								}
								if(this.$refs.notPosition.dialogVisible) {
									this.$refs.notPosition.dialogVisible = false;
								}
								if(this.$refs.notRoute.dialogVisible) {
									this.$refs.notRoute.dialogVisible = false;
								}
								// 清空店铺勾选
								this.$refs.multipleTable.clearSelection();
								this.routeSelection = [];
								this.routeInfoList();
							}
						});
				})
				.catch(() => {

				});
		},
		// 路线客商渠道统计弹窗
		handleRouteStatistics() {
			let channelsList = JSON.parse(JSON.stringify(this.channelsList));
			this.$refs.routeSum.init(channelsList);
		},
		// 路线客商配送周期调整弹窗
		handleChangeCycle(routeId) {
			let channelsList = JSON.parse(JSON.stringify(this.channelsList));
			this.$refs.changeCycle.init(channelsList, routeId);
		},
		// 变更路线类型
		changeRouteType(id, type) {
			for (const route of this.routeList) {
				if(route.routeId == id) {
					route.routeType = type;
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.container {
	position: relative;
	height: calc(100vh - 77px);
	margin: 10px;
}
.search-container {
	min-height: 40px;
	box-sizing: border-box;
	padding: 4px;
	position: relative;
	.el-button {
		height: 30px;
		line-height: 30px;
		padding: 0 20px;
		margin-right: 10px;
	}
}
.channel-content {
	display: inline-block;
	position: relative;
	ul {
		width: 146px;
		position: absolute;
		left: 0;
		top: 33px;
		z-index: 2;
		padding: 10px;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
		li {
			list-style: none;
			margin-bottom: 10px;
			&:last-child {
				margin-bottom: 0;
			}
			.el-checkbox-group {
				display: inline-block;
				width: 110px;
			}
			img {
				width: 24px;
				vertical-align: middle;
				cursor: pointer;
			}
		}
	}
}
.area-list-content {
	display: inline-block;
	position: relative;
	ul {
		width: 146px;
		position: absolute;
		left: 6px;
		top: 33px;
		z-index: 99;
		padding: 10px;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
		li {
			list-style: none;
			margin-bottom: 10px;
			&:last-child {
				margin-bottom: 0;
			}
			.el-checkbox-group {
				display: inline-block;
				width: 110px;
			}
			img {
				width: 24px;
				vertical-align: middle;
				cursor: pointer;
			}
		}
	}
}
.add-polygon-content {
	display: flex;
	position: absolute;
	height: 32px;
	align-items: center;
	top: 4px;
	right: 4px;
	& > img:nth-child(1) {
		width: 30px;
		height: 30px;
		margin-right: 10px;
		cursor: pointer;
        border-radius: 3px;
	}
	div {
		display: inline-block;
		img:nth-child(1) {
			margin-top: 4px;
			width: 30px;
			height: 30px;
			cursor: pointer;
            border-radius: 3px;
		}
	}
	ul {
		transition: all 1s;
		position: absolute;
		right: -3px;
		top: 40px;
		z-index: 1;
		padding: 10px;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
		li {
			list-style: none;
			margin-bottom: 10px;
			&:last-child {
				margin-bottom: 0;
			}
			button {
				width: 90px;
			}
		}
	}
}
.content {
	display: flex;
}
.route-table {
	width: 100%;
	height: 100%;
}
#container {
	height: 100%;
}
.left-table-content {
	width: 300px;
	table {
		width: 100%;
		border-collapse: collapse;
		tr {
			font-size: 12px;
			input[type="checkbox"] {
				width: 15px;
				height: 15px;
			}
			th {
				font-weight: normal;
				background-color: #ddd;
			}
			td,
			th {
				border-left: 1px solid #ccc;
				border-top: 1px solid #ccc;
				padding: 5px 2px;
				&:last-child {
					border-right: 1px solid #ccc;
					border-bottom: 1px solid #ccc;
				}
			}
		}
	}
}
.right-map-content {
	flex: 1;
}
.left-table-content /deep/ .el-table .cell,
.left-table-content /deep/ .el-table .el-table__cell,
.left-table-content /deep/ .el-table th.el-table__cell > .cell {
	padding: 0;
}

.left-table-content /deep/ .el-table .cell,
.left-table-content /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding-left: 0;
}
.left-table-content /deep/ .el-table th{
	height: 37px;
}
.icon-s {
	width: 30px;
	height: 30px;
	cursor: pointer;
	vertical-align: middle;
}

.fs13{
	font-size: 13px;
}

.route-btn-box{
	padding: 6px 10px;
}

.inline-block{
	display: inline-block;
}

.width120{
	width: 120px;
}
.sale-select{
	width: 120px;
}

.width60{
	width: 60px;
}

.width80{
	width: 80px;
}

.width160{
	width: 160px;
}

.search-btn{
	line-height: 30px;
	color: #fff;
    background-color: #1bc9b5;
	border: none;
	padding: 0 10px;
	border-radius: 5px;
	margin-left: 10px;
	font-size: 13px;
	cursor: pointer;
	&:hover{
		opacity: 0.9;
	}
}

.not-position-btn{
	position: absolute;
	left: 310px;
	z-index: 999;
	line-height: 30px;
	color: #fff;
    background-color: #1bc9b5;
	border: none;
	padding: 0 10px;
	border-radius: 5px;
	margin-left: 10px;
	font-size: 13px;
	cursor: pointer;
	&:hover{
		opacity: 0.9;
	}
}

.fr{
	float: right;
}

.pl4{
	padding-left: 4px;
}

.ml8{
	margin-left: 8px;
}

.ml70 {
	margin-left: 66px;
}

.group-box{
	border-top: 1px solid #DCDFE6;
	padding: 5px 8px;
	text-align: right;
	span{
		font-size: 14px;
		font-weight: bold;
		color: rgb(51, 51, 51);
	}
}

.imagestyle{
	background-color: #D9ECE9;
    box-sizing: border-box;
    padding: 5px;
	border-radius: 3px;
}

.cursor-pointer {
	cursor: pointer;
}

.view-btn {
	border: none;
	outline: none;
	color: #1bc9b5;
	background-color: rgba(27, 201, 181, 0.1);
	padding: 5px;
	border-radius: 3px;
	cursor: pointer;
}
</style>
<style>
.custom-content-marker{
	position: relative;
	width: 30px;
	height: 30px;
}
.custom-content-marker>div{
	position: absolute;
    width: 30px;
    height: 30px;
    top: 0;
    left: 0;
    color: white;
    text-align: center;
    font-size: 12px;
    line-height: 24px;
}
.custom-content-marker>.marker-icon {
	position: absolute;
    width: 10px;
    top: 0;
    left: 0;
}
.el-message .map-tips{
	line-height: 22px;
	color: red;
}
.el-select-dropdown__wrap{
	max-height: 300px;
}

.pl3 {
	padding-left: 3px !important;
}
</style>
